module.exports = __webpack_public_path__ + "static/media/slide-coupon-on.e6eb7581.svg";